import '../hybrid/globals.js';
import Loader from './loader.js';
import Observer from '../hybrid/observer.js';
import Localisation from '../hybrid/localisation.js';
import WebSocketClient from './web-socket.js';
import Receiver from './receiver.js';
import Provider from './provider.js';
import Navigation from './navigation.js';

// --- Vidoriel removed ---
// Vidoriel.translate and vidorielGlobalControllerHandler
// moved to client/adapters/vidoriel-adapter.js

globalThis.config = ssr.config;
globalThis.state = {};
state.language = ssr.language;
globalThis.baseUrl = document.baseURI.slice(0, -1);
globalThis.observer = new Observer();
globalThis.loader = new Loader();
globalThis.webSocket = new WebSocketClient();
globalThis.provider = new Provider();
globalThis.receiver = new Receiver();
globalThis.localisation = new Localisation(ssr.language, ssr.localisations);
globalThis._ = localisation._; // access localisations from {#placeholder} with _(placeholder) and _.placeholder

globalThis.$ = function(selector, base = document) {
	return base.querySelector(selector);
};

globalThis.$$ = function(selector, base = document) {
	return base.querySelectorAll(selector);
};

globalThis.on = function(
	nodes,
	events,
	selector,
	callback,
	options = undefined,
) {
	if (nodes === null) {
		return;
	}
	if (typeof nodes === 'string') {
		nodes = $$(nodes);
	}
	if (typeof nodes[Symbol.iterator] !== 'function') {
		nodes = [nodes];
	}
	for (const event of events.replace(',', ' ').split(' ')) {
		if (typeof selector == 'function' && typeof callback !== 'function') {
			for (const node of nodes) {
				node.addEventListener(
					event,
					event => {
						selector(event, node);
					},
					callback,
				);
			}
		} else {
			for (const node of nodes) {
				node.addEventListener(
					event,
					event => {
						if (event.target && event.target.closest && event.target.closest(selector)) {
							callback(event, event.target.closest(selector));
						}
					},
					options,
				);
			}
		}
	}
};

globalThis.trigger = function(nodes, action, options = { bubbles: true }) {
	if (typeof nodes[Symbol.iterator] !== 'function') {
		nodes = [nodes];
	}
	for (const node of nodes) {
		node.dispatchEvent(new Event(action, options));
	}
};

globalThis.isClass = function(func) {
	const descriptor = Object.getOwnPropertyDescriptor(func, 'prototype');
	return descriptor && !descriptor.writable;
};

/**
 * Import and instantiate a controller from a path.
 * This is render-agnostic — works for both Vidoriel and Canvas.
 * 
 * @param {string} controller - the path to the controller
 * @param {object} data - the data to pass and assign to the controller
 * @returns {object} the controller
 */
globalThis.importFrontendHandler = async function(frontendHandler, data) {
	let c = {};
	const module = await import('/crates' + frontendHandler);
	if (module.default instanceof Function) {
		if (isClass(module.default)) {
			c = new module.default(data);
			// Warn if class has constructor but no init() - constructor's this is not reactive
			const hasConstructor = module.default.toString().includes('constructor');
			const hasInit = typeof c.init === 'function';
			if (hasConstructor && !hasInit) {
				console.warn(`[Hybrilior] Class frontend handler "${frontendHandler}" has a constructor but no init() method. Arrow functions in constructor will not have reactive 'this'. Use init() for event handlers.`);
			}
		} else {
			c = module.default(data);
		}
	} else {
		for (const func in module) {
			if (typeof module[func] === 'function') {
				c[func] = module[func];
			}
		}
	}
	Object.assign(c, data);
	c.patchBlock = true;
	c.$module = module;
	c.patchBlock = false;
	module.$meta.lastController = c;
	return c;
};
// Backward compatibility alias
globalThis.importController = globalThis.importFrontendHandler;

// Navigation must be created after utility globals ($, on, etc.) are defined
globalThis.navigation = new Navigation();
